import browser from '@/libs/browser';

const app = {
    AppSettings: {
        module: 'AppSettings',
        method: {
            getSkin: 'getSkin'
        }
    },
    Trade: {
        module: 'Trade',
        method: {
            getAccountInfo: 'getAccountInfo',
            getGlobalConfiguration: 'getGlobalConfiguration'
        }
    },
    Upload: {
        module: 'Upload',
        method: {
            openLocalGallery: 'openLocalGallery'
        }
    },
    Permissions: {
        module: 'Permissions',
        method: {
            getPermissionStatus: 'getPermissionStatus',
            request: 'request'
        }
    },
    PushNotification: {
        module: 'PushNotification',
        method: {
            requestPermissions: 'requestPermissions'
        }
    }
};
let callbackCount = 1;
// 执行器
function invoke(options, callback) {
    const callHybridMethodJson = {
        moduleName: options.moduleName,
        methodName: options.methodName,
        requestJson: options.requestJson || {}
    };
    if (callback) {
        const callbackName = `${options.moduleName}_${options.methodName}_${callbackCount}`;
        callHybridMethodJson['callbackName'] = callbackName;
        window[callbackName] = callback;
        callbackCount += 1;
    }

    if (browser.isAndroid()) {
        const { __EM } = window;
        if (__EM) {
            __EM.prompt('callHybridMethod', JSON.stringify(callHybridMethodJson));
        }
    } else if (browser.isIOS()) {
        const { webkit } = window;
        if (webkit && webkit.messageHandlers && webkit.messageHandlers.callHybridMethod) {
            webkit.messageHandlers.callHybridMethod.postMessage(
                JSON.stringify(callHybridMethodJson)
            );
        }
    }
}

export const AppSettings = {
    getSkin() {
        return new Promise((resolve, reject) => {
            invoke(
                {
                    moduleName: app.AppSettings.module,
                    methodName: app.AppSettings.method.getSkin,
                    requestJson: {}
                },
                res => {
                    if (res.code == '1') {
                        resolve(res.data.mode);
                    } else {
                        reject(res);
                    }
                }
            );
        });
    }
};
export const Trade = {
    /**
     * 获取交易账号信息
     * @returns
     */
    getAccountInfo() {
        return new Promise((resolve, reject) => {
            invoke(
                {
                    moduleName: app.Trade.module,
                    methodName: app.Trade.method.getAccountInfo,
                    requestJson: { module: 'hs' }
                },
                res => {
                    if (res.code == '1') {
                        resolve(res.data);
                    } else {
                        reject(res);
                    }
                }
            );
        });
    },
    /**
     * 获取交易全局配置
     * @returns
     */
    getGlobalConfiguration() {
        return new Promise((resolve, reject) => {
            invoke(
                {
                    moduleName: app.Trade.module,
                    methodName: app.Trade.method.getGlobalConfiguration,
                    requestJson: { module: 'hs' }
                },
                res => {
                    if (res.code == '1') {
                        resolve(res.data);
                    } else {
                        reject(res);
                    }
                }
            );
        });
    }
};

// 原生交互，权限相关
export const Permissions = {
    getPermissionStatus(permission) {
        return new Promise((resolve, reject) => {
            invoke(
                {
                    moduleName: app.Permissions.module,
                    methodName: app.Permissions.method.getPermissionStatus,
                    requestJson: {
                        permission: permission
                    }
                },
                res => {
                    if (res && res.code == '1') {
                        const data = res.data;
                        resolve(data.status);
                    } else {
                        console.log('===getPermissionStatus===', res);
                        reject();
                    }
                }
            );
        });
    },
    request(permission) {
        return new Promise((resolve, reject) => {
            invoke(
                {
                    moduleName: app.Permissions.module,
                    methodName: app.Permissions.method.request,
                    requestJson: {
                        permission: permission
                    }
                },
                res => {
                    console.log('request', JSON.stringify(res));
                    if (res && res.code == '1') {
                        resolve();
                    } else {
                        reject(res);
                    }
                }
            );
        });
    }
};
// 上传相关
export const Upload = {
    // 打开相册
    openLocalGallery(requestJson) {
        return new Promise((resolve, reject) => {
            invoke(
                {
                    moduleName: app.Upload.module,
                    methodName: app.Upload.method.openLocalGallery,
                    requestJson: requestJson
                },
                res => {
                    if (res && res.code == '1') {
                        resolve(res.data);
                    } else {
                        reject();
                    }
                }
            );
        });
    }
};

export const PushNotification = {
    // 打开设置页面
    requestPermissions() {
        invoke({
            moduleName: app.PushNotification.module,
            methodName: app.PushNotification.method.requestPermissions
        });
    }
};
